import { estimateGasCreateTieredEdition } from '../actions/public/estimateGasCreateTieredEdition.mjs';
import { estimateGasMintTieredEdition } from '../actions/public/estimateGasMintTieredEdition.mjs';
import { getEditionContractInfo } from '../actions/public/getEditionContractInfo.mjs';
import { getExpectedEditionAddress } from '../actions/public/getExpectedEditionAddress.mjs';
import { getMintEligibility } from '../actions/public/getMintEligibility.mjs';
import { getMintingSchedules } from '../actions/public/getMintingSchedules.mjs';
import { getPlatformFees } from '../actions/public/getPlatformFees.mjs';
import { getTotalMintPriceAndFees } from '../actions/public/getTotalMintPriceAndFees.mjs';

function publicTieredEditionActions(client) {
  return {
    getEditionContractInfo: (args) => getEditionContractInfo(client, args),
    getMintingSchedules: (args) => getMintingSchedules(client, args),
    getExpectedEditionAddress: (args) => getExpectedEditionAddress(client, args),
    getPlatformFees: (args) => getPlatformFees(client, args),
    getMintEligibility: (args) => getMintEligibility(client, args),
    estimateGasCreateTieredEdition: (args) => estimateGasCreateTieredEdition(client, args),
    estimateGasMintTieredEdition: (args) => estimateGasMintTieredEdition(client, args),
    getTotalMintPriceAndFees: (args) => getTotalMintPriceAndFees(client, args)
  };
}

export { publicTieredEditionActions };
